import { getAccessibilityScoreDic } from '../AccessibilityScore.consts';
import { StyledScoreSeparator } from '../AccessibilityScore.styles';
import { ScoreCard } from './ScoreCard';
import { StyledScoreCard } from './ScoreCard.styles';

export const MobileStoreCards: React.FC = () => {
  const scoreKeys = Object.keys(getAccessibilityScoreDic());
  return (
    <StyledScoreCard $gap={24}>
      {scoreKeys.map((scoreName, i) => (
        <>
          <ScoreCard key={`score${i}`} $scoreName={scoreName} />
          {i < scoreKeys.length - 1 && <StyledScoreSeparator />}
        </>
      ))}
    </StyledScoreCard>
  );
};
